import { render, staticRenderFns } from "./premium-nyan2.vue?vue&type=template&id=dc6370b0&scoped=true"
import script from "./premium-nyan2.vue?vue&type=script&lang=js"
export * from "./premium-nyan2.vue?vue&type=script&lang=js"
import style0 from "./premium-nyan2.vue?vue&type=style&index=0&id=dc6370b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6370b0",
  null
  
)

export default component.exports